import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import FieldCategories from "./fieldCategories";

const feature = "fieldCategories";

const InitialState = Record({
  fieldCategories: new FieldCategories()
});

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function fieldCategoriesReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
        action.payload.entities &&
        action.payload.entities.fieldCategories
    ) {
      state = state.updateIn(
        ["fieldCategories", "entities"],
        map => map.mergeDeep(action.payload.entities.fieldCategories)
      );
    }
  }

  switch (action.type) {
    case actions.GET_FIELD_CATEGORIES: {
      return state.setIn(["fieldCategories", "loading"], true);
    }
    case actions.GET_FIELD_CATEGORIES_SUCCESS: {
      state = state.deleteIn(["fieldCategories", "entities"]);
      state = state.deleteIn(["fieldCategories", "results"]);
      state = state.setIn(
        ["fieldCategories", "meta", "all"],
        action.payload.result.meta.all
      );
      state = state.setIn(
        ["fieldCategories", "meta", "count"],
        action.payload.result.meta.count
      );
      state = state.updateIn(
        ["fieldCategories", "entities"],
        map => map.mergeDeep(action.payload.entities.fieldCategories)
      );
      state = state.setIn(
        ["fieldCategories", "results"],
        action.payload.result.fieldCategories
      );
      return state.setIn(["fieldCategories", "loading"], false);
    }
    case actions.GET_FIELD_CATEGORIES_ERROR: {
      return state.setIn(["fieldCategories", "loading"], false);
    }

    case actions.GET_FIELD_CATEGORY: {
      return state.setIn(["fieldCategories", "loading"], true);
    }
    case actions.GET_FIELD_CATEGORY_SUCCESS: {
      return state.setIn(["fieldCategories", "loading"], false);
    }
    case actions.GET_FIELD_CATEGORY_ERROR: {
      return state.setIn(["fieldCategories", "loading"], false);
    }

    case actions.PATCH_FIELD_CATEGORY: {
      return state.setIn(["fieldCategories", "loading"], true);
    }
    case actions.PATCH_FIELD_CATEGORY_SUCCESS: {
      return state.setIn(["fieldCategories", "loading"], false);
    }
    case actions.PATCH_FIELD_CATEGORY_ERROR: {
      return state.setIn(["fieldCategories", "loading"], false);
    }

    case actions.DELETE_FIELD_CATEGORY: {
      return state.deleteIn([
        "fieldCategories",
        "entities",
        action.payload.uid
      ]);
    }

    case actions.SET_IS_REMOVE_FIELD_CATEGORY_MODAL_VISIBLE: {
      return state.setIn(
        ["fieldCategories", "isRemoveModalVisible"],
        action.payload.isVisible
      );
    }
    case actions.SET_IS_EDIT_FIELD_CATEGORY_MODAL_VISIBLE: {
      return state.setIn(
        ["fieldCategories", "isEditModalVisible"],
        action.payload.isVisible
      );
    }

  }

  return entitiesReducer(state, feature, action);
}



// WEBPACK FOOTER //
// ./src/common/fieldCategories/reducer.js